// extracted by mini-css-extract-plugin
module.exports = {"view":"Login_view__2AlQx","wrapper":"Login_wrapper__1Syn3","firebaseUIWrapper":"Login_firebaseUIWrapper__rikXZ"};